/**
 * @module Menu
 *
 * Viewport-aware menu system wrapping Bloom.
 *
 * Provides styled menu components with automatic viewport detection.
 * When a submenu would overflow the viewport, the entire menu shifts up.
 */

import * as BloomMenu from "bloom-menu";

import { MenuContainer } from "./menu-container";
import { MenuContent, type MenuContentProps } from "./menu-content";
import { MenuDivider } from "./menu-divider";
import { MenuItem, type MenuItemProps } from "./menu-item";
import { MenuRoot, type MenuRootProps } from "./menu-root";
import { MenuSubMenu, type MenuSubMenuProps } from "./menu-submenu";
import {
  MenuSubMenuContent,
  type MenuSubMenuContentProps,
} from "./menu-submenu-content";
import {
  MenuSubMenuTrigger,
  type MenuSubMenuTriggerProps,
} from "./menu-submenu-trigger";

export const Menu = {
  Root: MenuRoot,
  Container: MenuContainer,
  Trigger: BloomMenu.Trigger,
  Content: MenuContent,
  Item: BloomMenu.Item,
  MenuItem,
  Divider: MenuDivider,
  SubMenu: MenuSubMenu,
  SubMenuTrigger: MenuSubMenuTrigger,
  SubMenuContent: MenuSubMenuContent,
};

export type {
  MenuRootProps,
  MenuContentProps,
  MenuSubMenuContentProps,
  MenuSubMenuProps,
  MenuSubMenuTriggerProps,
  MenuItemProps,
};
